import { Tooltip } from "antd";
import { Checkbox } from "antd-v5";
import { CheckboxChangeEvent } from "antd-v5/lib/checkbox";
import { HelpIcon } from "components/Icons";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";

type TrivyDedupeCheckboxHandleType = {
  getValue: () => boolean;
};

// component accepts no props, thus _: any
// this matches the forwardRef signature
function TrackTrivyLatestVersionFindingsCheckbox(
  _: any,
  ref: React.Ref<TrivyDedupeCheckboxHandleType>,
) {
  const [checked, setChecked] = useState<boolean>(false);
  useEffect(() => {
    const { promise, cancel } = GlobalSettingAPI.getTenantConfig(
      "TRIVY_DEDUP_WITHOUT_IMAGE_ID",
    );
    promise
      .then((res) => {
        setChecked(res);
      })
      .catch((err) => {
        console.error("Error fetching config:", err);
      });

    return cancel;
  }, []);

  useImperativeHandle(ref, () => {
    return {
      getValue: () => {
        return checked;
      },
    };
  });

  return (
    <Checkbox
      onChange={(e: CheckboxChangeEvent) => setChecked(e.target.checked)}
      value={checked}
      checked={checked}
    >
      Automatically resolve findings not present in latest container image scan{" "}
      <Tooltip
        title="When enabled, ArmorCode considers the most recently ingested scan
    for a container image (irrespective of its version or tag) as the
    definitive source of truth. Any findings not present in this scan
    will be automatically marked as resolved. <br></br>
    Note: This option should only be enabled if scans are uploaded in
    a sequential and incremental manner, where each new scan reflects
    an updated version of the same image."
      >
        <span>
          <HelpIcon />
        </span>
      </Tooltip>
    </Checkbox>
  );
}

export default forwardRef(TrackTrivyLatestVersionFindingsCheckbox);
